// Return total number of questions and how many were answered
const calculateStats = (questions) => {
  const total = questions.reduce((total, category) => (total += category.questions.length), 0);
  const answered = questions.reduce(
    (count, category) =>
      (count += category.questions.filter((question) => question.answer !== undefined).length),
    0
  );

  return { total, answered };
};

// Return total number of questions in one particular section,
// the number of answered questions in that section and how many were
// positively answered
const calculateCategoryStats = (questions, categoryIndex) => {
  const total = questions[categoryIndex].questions.length;

  const answered = questions[categoryIndex].questions.filter(
    (question) => question.answer !== undefined
  ).length;

  const positive = questions[categoryIndex].questions.filter((question) => question.answer === true)
    .length;

  return { total, answered, positive };
};

// Return zero when question bank is empty
// Calculate individual ratings for all categories
// Return the rounded average for all category ratings
const calculateRatings = (questions) => {
  if (!questions.length) return 0;

  const ratings = questions.map((category, categoryIndex) =>
    calculateCategoryRating(questions, categoryIndex)
  );
  const rating = ratings.reduce((total, rating) => (total += rating), 0) / questions.length;

  return { overall: Math.round(rating), byCategory: ratings };
};

// Return zero when question bank is empty
// Calculate percentage of positively answered questions
// Assign rating based on percentage thresholds
const calculateCategoryRating = (questions, categoryIndex) => {
  if (!questions.length) return 0;

  const stats = calculateCategoryStats(questions, categoryIndex);
  const rating = stats.positive / stats.total;

  if (rating >= 0.8) return 5;
  if (rating >= 0.6) return 4;
  if (rating >= 0.4) return 3;
  if (rating >= 0.2) return 2;
  if (rating >= 0.05) return 1;
  return 0;
};

export default {
  calculateStats,
  calculateCategoryStats,
  calculateRatings,
  calculateCategoryRating
};
